/* ============================================================
   JANIBORAMO — MAGIC JS
   Interacciones progresivas para "Copia de Whisper".
   No elimina ni reemplaza funcionalidad nativa del tema:
   solo añade clases, observadores y listeners adicionales.
   ============================================================ */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ------------------------------------------------------------
     Utilidad: envolver una frase exacta en un <span> dentro de un
     contenedor, sin tocar otros nodos ni atributos existentes.
     ------------------------------------------------------------ */
  function wrapPhrase(root, phrase, className) {
    if (!root || !phrase) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var targets = [];
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.indexOf(phrase) !== -1) {
        targets.push(node);
      }
    }
    targets.forEach(function (textNode) {
      var parts = textNode.nodeValue.split(phrase);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part, i) {
        if (part) frag.appendChild(document.createTextNode(part));
        if (i < parts.length - 1) {
          var span = document.createElement("span");
          span.className = className;
          span.textContent = phrase;
          frag.appendChild(span);
        }
      });
      textNode.parentNode.replaceChild(frag, textNode);
    });
  }

  /* ------------------------------------------------------------
     1. Revelado progresivo al hacer scroll
     ------------------------------------------------------------ */
  function markReveal(el) {
    if (el && !el.classList.contains("jbo-reveal")) {
      el.classList.add("jbo-reveal");
    }
  }

  function initReveal() {
    var els = [];

    var heroContent = qs('[id$="__hero_p9CmMG"] .hero__content-wrapper');
    if (heroContent) { markReveal(heroContent); els.push(heroContent); }

    qsa('[id$="__section_TCxiGg"] h1, [id$="__section_TCxiGg"] h2, ' +
        '[id$="__section_TCxiGg"] p, [id$="__section_TCxiGg"] a.button')
      .forEach(function (el) { markReveal(el); els.push(el); });

    var universoHeading = qs('[id$="__section_universo_cuidar"] h2');
    if (universoHeading) { markReveal(universoHeading); els.push(universoHeading); }
    qsa('[id$="__section_universo_cuidar"] .group-block--width-custom')
      .forEach(function (el) { markReveal(el); els.push(el); });

    qsa('[id$="__section_g4dgzx"] h2, [id$="__section_g4dgzx"] p')
      .forEach(function (el) { markReveal(el); els.push(el); });

    qsa(".jbo-historia-heading, .jbo-historia-block")
      .forEach(function (el) { markReveal(el); els.push(el); });

    if (reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("jbo-inview"); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("jbo-inview");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ------------------------------------------------------------
     2. Frases clave con identidad propia
     ------------------------------------------------------------ */
  function initPhraseHighlights() {
    var formaBonita = qs('[id$="__section_TCxiGg"]');
    wrapPhrase(formaBonita, "Una forma bonita de querer", "jbo-highlight");
    wrapPhrase(formaBonita, "Que te pasen cosas bonitas.", "jbo-highlight");

    var teaser = qs('[id$="__section_g4dgzx"]');
    if (teaser) {
      wrapPhrase(teaser, "JA · NI · BO · RA · MO", "jbo-acronym");
      ["Jagger", "Nico", "Botón", "Rabbit", "Molly"].forEach(function (name, i) {
        wrapPhrase(teaser, name, "jbo-name-" + (i + 1));
      });
    }

    var footer = qs('[id$="__section_AMNjDg"]') || qs('[id$="__footer_utilities"]');
    wrapPhrase(footer, "Que te pasen cosas bonitas.", "jbo-footer-tagline");
  }

  /* ------------------------------------------------------------
     3. Interacción táctil equivalente al hover (categorías)
     ------------------------------------------------------------ */
  function initTouchCards() {
    var cards = qsa('[id$="__section_universo_cuidar"] .group-block--width-custom');
    cards.forEach(function (card) {
      card.setAttribute("tabindex", "0");
      card.setAttribute("role", "button");
      card.setAttribute("aria-expanded", "false");

      function toggle() {
        var isActive = card.classList.contains("jbo-card--active");
        cards.forEach(function (c) {
          c.classList.remove("jbo-card--active");
          c.setAttribute("aria-expanded", "false");
        });
        if (!isActive) {
          card.classList.add("jbo-card--active");
          card.setAttribute("aria-expanded", "true");
        }
      }

      card.addEventListener("click", toggle);
      card.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  /* ------------------------------------------------------------
     4. "Nuestra historia": jerarquía visual automática
     ------------------------------------------------------------ */
  function initHistoria() {
    var main = qs("#shopify-section-template--31340353159454__main");
    if (!main) return;

    var titles = ["Propósito", "Misión", "Visión", "Valores"];
    var headings = qsa("h1, h2, h3, h4", main).filter(function (h) {
      var t = h.textContent.trim();
      return titles.some(function (title) { return t.indexOf(title) === 0; });
    });

    headings.forEach(function (heading) {
      heading.classList.add("jbo-historia-heading");

      var wrapper = document.createElement("div");
      wrapper.className = "jbo-historia-block";
      heading.parentNode.insertBefore(wrapper, heading.nextSibling);

      var node = wrapper.nextSibling;
      while (node && !(node.nodeType === 1 && /^H[1-4]$/.test(node.tagName))) {
        var next = node.nextSibling;
        wrapper.appendChild(node);
        node = next;
      }
    });
  }

  /* ------------------------------------------------------------
     Inicio
     ------------------------------------------------------------ */
  function init() {
    initPhraseHighlights();
    initHistoria();
    initTouchCards();
    initReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();